import { UserPanelView } from './userPanelView'

export const UserPanel = () => {
  return (
    <>
      <UserPanelView />
    </>
  )
}
